import { lastSignInError } from "../../../network/service/PlatformAuth";

/**
 * Shown only when the nutrition session is missing (e.g. first use after an
 * update) or has ended. The admin login signs in to the nutrition service
 * too, so nothing here asks the admin to log in.
 */
function PlatformSignInNotice() {
  const reason = lastSignInError();

  return (
    <div className="nutri-status nutri-status-warn">
      {reason
        ? `Health grades are unavailable: ${reason} when you logged in.`
        : "Health grades are unavailable for this session."}{" "}
      Sign out and log in again to reconnect.
    </div>
  );
}

export default PlatformSignInNotice;
